import { FC } from "react";
import { CardMetadataProps } from "../../types";
import Metadata from "../../../Card/components/Metadata/component";

const CardMetadata: FC<CardMetadataProps> = ({
    metadataId,
    publishTime,
    updateTime,
    departments,
    baseSection,
    subSection,
    displayComments,
}) => {
    if (
        !metadataId ||
        (!departments?.sectionList?.length &&
            !departments?.sectionLabels?.length)
    )
        return null;

    const metadataProps = {
        id: metadataId,
        published: publishTime,
        updated: updateTime,
        // departments is being deprecated, need to find out what will replace it
        departments,
        baseSection,
        subSection,
        displayComments,
    };

    return (
        <div className="card-cqw-metadata" data-testid="card-cqw-metadata">
            <Metadata {...metadataProps} />
        </div>
    );
};

export default CardMetadata;
